<p [ngClass]="textFieldClasses">
  {{textFieldValue | translate}}
</p>
<pcs-tooltip *ngIf="showTooltipForValue; else showTooltipWithContent" tabIndex="-1" [container]="tooltipContainer">
  {{textFieldValue | translate}}
</pcs-tooltip>
<ng-template #showTooltipWithContent>
  <ng-content></ng-content>
</ng-template>
